import React, { useState, useMemo, useEffect , useRef} from "react";
 import { Search, ChevronDown } from 'lucide-react';
 import { useAuth } from '../hooks/useAuth';

const ElevenLabsLibrary = () => {
  const API_KEY = "";
  const PAGE_SIZE = 6;
  const API_URL = process.env.NODE_ENV === 'development' ? "https://demo.aiguardian.io/agent-backend": "/agent-backend";
  const [voices, setVoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedVoice, setSelectedVoice] = useState(null);
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);

   const dropdownRef = useRef(null);

  

  const fetchVoices = async (p = page) => {
    setLoading(true);
    try {
      const res = await fetch(
        API_URL + '/api/my-voices',
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${user.token}`
          },
        }
      );
      const data = await res.json();
      setVoices(data.voices || []);
    } catch (err) {
      console.error("Error fetching voices:", err);
    }
    setLoading(false);
  };

  
  // fetch on initial load and when page changes
  useEffect(() => { fetchVoices(page); }, [page]);

  // 🔑 reset page to 1 whenever the search text changes
  useEffect(() => {
    // only bump to page 1 if we aren't already there
    if (page !== 1) setPage(1);
    // no refetch needed for client-side search
    // (we filter the current page below)
  }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

useEffect(() => {
  if ( voices.length === 0 && page > 1) {
    setPage(p => Math.max(1, p - 1)); // rollback
  }
}, [voices, loading, page]);

  const playVoice = (url) => {
    if (!url) return;
    new Audio(url).play();
  };

 // client-side filter on the current page
  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return voices;
    return voices.filter(v => (v.name || "").toLowerCase().includes(q));
  }, [voices, search]);

  return (
    <div className="w-full ">
      


                <div className="relative mb-6" ref={dropdownRef}>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Voice
            </label>
            
            <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg flex items-center justify-between hover:border-purple-500 transition-colors"
            >
              <span className={selected ? 'text-gray-800' : 'text-gray-500'}>
                {selected ? selected.name : 'Choose a voice...'}
              </span>
              <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
              <div className="absolute w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                <div className="p-3 border-b">
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search voices..."
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                      autoFocus
                    />
                  </div>
                </div>

                <div className="max-h-64 overflow-y-auto">
                  {filtered.length === 0 ? (
                    <div className="p-4 text-center text-gray-500">
                      No voices found
                    </div>
                  ) : (
                    filtered.map((voice) => (
                      <button
                        key={voice.voice_id}
                        onClick={() => {
                          setSelected(voice);
                          setIsOpen(false);
                          setSearch('');
                        }}
                        className={`w-full px-4 py-3 text-left hover:bg-purple-50 transition-colors flex items-center gap-3 ${
                          selected?.voice_id === voice.voice_id ? 'bg-purple-100' : ''
                        }`}
                      >
                        
                        <div className="flex-1">
                          <div className="font-medium text-gray-800">
                            {voice.name}
                          </div>
                          <div className="text-xs text-gray-500">
                            {voice.category}
                          </div>
                        </div>
                      </button>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>   

          <div className="flex-grow">
            <div >

              <div className="flex items-center justify-between mb-2">
                

                {/* Tooltip for Description */}
                {/* {selected?.description && (
                  <div className="relative group">
                    <span className="cursor-pointer text-gray-500">ℹ️</span>
                    <div className="absolute bottom-full right-0 mb-2 hidden w-64 rounded-lg bg-black text-white text-xs p-2 group-hover:block shadow-lg">
                      {selected?.description}
                    </div>
                  </div>
                )} */}
              </div>
              

              {/* Extra Info */}
              
            </div>
            <div className="mt-4">
            {selected?.preview_url ? (
              <audio
                controls
                src={selected?.preview_url}
                className="w-full"
              /> 
            ) : (
             <></>
            )}
           </div> 
        </div>


    
    </div>
  );
};

export default ElevenLabsLibrary;
